// @ts-check
import { html } from 'htm/preact';
import { PageCard } from '../modules/page/page-card.js';
import { EmptyState } from '../ui/feedback.js';
import { Button } from '../ui/button.js';
import { navigate } from './router.js';
import { t } from '../i18n/index.js';

/** @param {{ subtitle?: string }} [props] subtítulo próprio (registro fora das etapas do papel) */
export function NotFoundPage({ subtitle } = {}) {
  return html`<${PageCard}>
    <div class="page-centered">
      <${EmptyState}
        icon="IconMapPin"
        title=${t('notFound.title')}
        subtitle=${subtitle ?? t('notFound.subtitle')}
        action=${html`<${Button} variant="secondary" title=${t('notFound.back')} onClick=${() => navigate('/')} />`}
      />
    </div>
  <//>`;
}
